module.exports = require('./helpers/bundle-url').getBundleURL('8noT4') + "annotation-result-skipped-icon.324bf075.svg";